import { Boolean, Partial, Record, String } from "runtypes";
import { SubmissionCoordinates } from "./coordinates";
export const Collaboration = SubmissionCoordinates.And(
  Partial({
    to: String
  })
);
export const SavedCollaboration = Collaboration.And(
  Record({
    number: String,
    semester: String,
    email: String,
    joined: Boolean
  })
).And(
  Partial({
    disabled: Boolean
  })
);
//# sourceMappingURL=collaboration.js.map
